<template>
  <node-view-wrapper class="igi" contenteditable="false">
    <image-ext
      v-model="imageAssets"
      :src="node.attrs.src"
      :limit-height="200"
      :thumb-x="30"
      :thumb-y="30"
    />

    <div class="igi__controls">
      <div class="drag-handle" draggable="true" data-drag-handle>
        <v-icon color="white">mdi-drag</v-icon>
      </div>
      <v-icon color="white" @click="onCloseClick">
        mdi-close
      </v-icon>
    </div>
  </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-2";
import ImageExt from "@/components/ImageExt.vue";

export default {
  components: {
    NodeViewWrapper,
    ImageExt
  },
  props: nodeViewProps,
  computed: {
    imageAssets: {
      get() {
        const { contain, fill, left, top, right, bottom } = this.node.attrs;
        return { contain, fill, left, top, right, bottom };
      },
      set(val) {
        const { contain, fill, position, left, top, right, bottom } = val;
        if (this.node.attrs.contain != contain) {
          this.updateAttributes({ contain });
        }
        if (this.node.attrs.fill != fill) {
          this.updateAttributes({ fill });
        }
        if (this.node.attrs.position != position) {
          this.updateAttributes({ position });
        }
        if (this.node.attrs.left != left) {
          this.updateAttributes({ left });
        }
        if (this.node.attrs.top != top) {
          this.updateAttributes({ top });
        }
        if (this.node.attrs.right != right) {
          this.updateAttributes({ right });
        }
        if (this.node.attrs.bottom != bottom) {
          this.updateAttributes({ bottom });
        }
      }
    }
  },
  methods: {
    onCloseClick() {
      this.deleteNode();
    }
  }
};
</script>

<style lang="scss" scoped>
.igi {
  background: #fff;
  border: 1px solid #0d0d0d;
  margin: 8px;
  position: relative;
  flex-grow: 0;
  max-width: 300px;

  .igi__controls {
    position: absolute;
    right: 0;
    top: 0;
    background-color: rgba(100, 100, 100, 0.5);
    display: none;
  }

  &:hover {
    .igi__controls {
      display: flex;
    }
  }
}
</style>
